module.exports = __webpack_public_path__ + "img/FTS_sword_sample.51007f6f.png";